import { IEventDataSource } from "@/types/interfaces";
import { BigBashEvent } from "@/types/types";
import { sharedStyles } from "@lib/sharedStyles";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("events-table")
export class EventsTable extends LitElement {
	static readonly styles = [
		sharedStyles,
		css`
		.events-table {
			display: flex;
			flex-direction: column;
			gap: 8px;
			padding: 8px;
		}

		.table-header {
			display: flex;
			padding: 8px;
			background: #f8f9fa;
		}

		.table-body {
			display: flex;
			flex-direction: column;
			gap: 16px;
		}

		.table-cell {
			flex: 1;
		}
	`];

	@property({ type: Array }) events: BigBashEvent[] = [];
	@property({ type: Object }) eventsDataSource: IEventDataSource;

	constructor(eventsDataSource: IEventDataSource) {
		super();
		this.eventsDataSource = eventsDataSource;
		this.addEventListener('delete-event', this._handleDeleteEvent);
	}

	private _handleDeleteEvent(e: CustomEvent) {
		this.events = this.events.filter(event => event.id !== e.detail.id);
	}

	private _sortEventsByDate(events: BigBashEvent[]) {
		return events.sort((a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime());
	}

	render() {
		return html`
			<div class="events-table">
				<div class="table-header">
					<div class="table-cell text-body--small">Datum</div>
					<div class="table-cell text-body--small">Gruppenname</div>
					<div class="table-cell text-body--small">Teilnehmer</div>
					<div class="table-cell text-body--small" style="flex: 2;">Aktionen</div>
				</div>
				<div class="table-body">
					${this._sortEventsByDate(this.events).map((ev) => html`<event-table-row .event=${ev} .eventDataSource=${this.eventsDataSource}></event-table-row>`)}
				</div>
			</div>
		`;
	}
}

export default EventsTable;